import React from 'react';
import PropTypes from 'prop-types';

import { SUBSCRIPTION_TYPES } from '../../../constants/subscriptions';

const SubscriptionSelector = ({
  selectedSubscription,
  onSubscriptionChange,
  providers,
}) => {
  const providerCount = providers.length;

  // Placeholder for future use when calculating totals per provider
  const _calculateTotal = (subscription) => {
    return (subscription.price * providerCount).toFixed(2);
  };

  return (
    <div className="flex flex-col items-start gap-6 pb-5 self-stretch lg:pb-0">
      <h2 className="text-2xl font-semibold leading-9 text-gray-90 self-stretch lg:text-2xl lg:leading-9 md:text-xl md:leading-8">
        Select your subscription
      </h2>
      <p className="text-sm font-extralight leading-5 text-gray-90 self-stretch">
        {`Your credit card will be charged either ${SUBSCRIPTION_TYPES.ANNUAL.displayPrice} yearly for the annual Healthgrades Elevated Profile Subscription or ${SUBSCRIPTION_TYPES.MONTHLY.displayPrice} per month for the monthly subscription, depending on the plan you choose.`}
      </p>

      <div className="flex flex-col items-start gap-5 self-stretch">
        {/* Annual Subscription */}
        <label className="bg-white flex items-center gap-2 shrink-0 self-stretch rounded-lg p-4 border-none cursor-pointer transition-all duration-300">
          <input
            type="radio"
            name="subscription"
            value={SUBSCRIPTION_TYPES.ANNUAL.id}
            checked={selectedSubscription?.id === SUBSCRIPTION_TYPES.ANNUAL.id}
            onChange={() => onSubscriptionChange(SUBSCRIPTION_TYPES.ANNUAL)}
            className="w-5 h-5 mt-0 shrink-0 accent-blue-50 cursor-pointer"
          />
          <span className="text-gray-90 grow text-sm font-semibold leading-5">
            <strong>{SUBSCRIPTION_TYPES.ANNUAL.label}</strong> -{' '}
            {SUBSCRIPTION_TYPES.ANNUAL.description} -{' '}
            {SUBSCRIPTION_TYPES.ANNUAL.priceLabel}
          </span>
        </label>

        {/* Monthly Subscription */}
        <label className="bg-white flex items-center gap-2 shrink-0 self-stretch rounded-lg p-4 border-none cursor-pointer transition-all duration-300">
          <input
            type="radio"
            name="subscription"
            value={SUBSCRIPTION_TYPES.MONTHLY.id}
            checked={selectedSubscription?.id === SUBSCRIPTION_TYPES.MONTHLY.id}
            onChange={() => onSubscriptionChange(SUBSCRIPTION_TYPES.MONTHLY)}
            className="w-5 h-5 mt-0 shrink-0 accent-blue-50 cursor-pointer"
          />
          <span className="text-gray-90 grow text-sm font-semibold leading-5">
            <strong>{SUBSCRIPTION_TYPES.MONTHLY.label}</strong> -{' '}
            {SUBSCRIPTION_TYPES.MONTHLY.description} -{' '}
            {SUBSCRIPTION_TYPES.MONTHLY.priceLabel}
          </span>
        </label>
      </div>
    </div>
  );
};

SubscriptionSelector.propTypes = {
  selectedSubscription: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    price: PropTypes.number,
    priceLabel: PropTypes.string,
  }),
  onSubscriptionChange: PropTypes.func.isRequired,
  providers: PropTypes.array,
};

SubscriptionSelector.defaultProps = {
  providers: [],
};

export default SubscriptionSelector;
